import type { StoryTileGridBackground } from "./StoryTile";

// Looks up styles for a background color, falling back to defaultStyles for any value
// (including future CMS options) not yet mapped, instead of crashing.
export const resolveGridBackgroundStyles = <T>(
    stylesByBackground: Partial<Record<StoryTileGridBackground, T>>,
    defaultStyles: T,
    backgroundColor: string
): T => stylesByBackground[backgroundColor as StoryTileGridBackground] ?? defaultStyles;

// Narrows an arbitrary CMS string down to a StoryTileGridBackground the UI package knows how to
// style, so passing it on to typed props (e.g. StoryTile's gridBackground) still compiles.
export const normalizeGridBackground = (
    stylesByBackground: Partial<Record<StoryTileGridBackground, unknown>>,
    backgroundColor: string,
    fallback: StoryTileGridBackground = "White"
): StoryTileGridBackground =>
    Object.prototype.hasOwnProperty.call(stylesByBackground, backgroundColor)
        ? (backgroundColor as StoryTileGridBackground)
        : fallback;
